// This file will be resolved by webpack aliases to the correct TradingViewContainer
// based on the REACT_APP_IS_INDIAN_EXCHANGE environment variable

import { IS_INDIAN_EXCHANGE } from 'constants/constants';

// The actual import will be resolved at build time by webpack aliases:
// - FundingTvContianer.tsx when REACT_APP_IS_INDIAN_EXCHANGE=true
// - FundingTVContainer.global.tsx when REACT_APP_IS_INDIAN_EXCHANGE=false
const FundingTvContainer = IS_INDIAN_EXCHANGE
  ? require('./FundingTvContainer').default
  : require('./FundingTVContainer.global').default;

export default FundingTvContainer;
